import useLocales from 'hooks/useLocales';
import { CSSProperties, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomModal } from './CustomModal';

const AIModal = ({
  open,
  onClose,
  customAvatar,
  customTitle,
  customMessage,
  titleStyle,
  textStyle,
  customButton,
  description
}: {
  open: boolean;
  onClose?: () => void;
  customAvatar?: string;
  customTitle?: string;
  customMessage?: string;
  titleStyle?: CSSProperties;
  textStyle?: CSSProperties;
  customButton?: ReactNode;
  description?: string;
}): JSX.Element => {
  const { t } = useLocales();
  return (
    <CustomModal open={open} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '13px',
          p: '15px'
        }}
      >
        <img
          src={customAvatar || '/static/img/illustrations/rocketship.svg'}
          alt="ai-avatar"
          style={{ maxWidth: '200px', maxHeight: '200px' }}
        />
        <Typography variant="h3" fontWeight={600} style={titleStyle}>
          {customTitle || t('The Magic is Working…')}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={400}
          color="#85878C"
          style={{ maxWidth: '276px', ...textStyle }}
        >
          {customMessage || t('NORA is working, please be patient.')}
        </Typography>
        {description && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              maxHeight: '300px',
              overflow: 'auto',
              fontSize: '14px',
              fontFamily: 'Arial, sans-serif',
              whiteSpace: 'pre-wrap',
              backgroundColor: '#f9f9f9',
              maxWidth: '500px',
              lineHeight: 1.6
            }}
          >
            {description}
          </Box>
        )}
        {customButton && customButton}
      </Box>
    </CustomModal>
  );
};

export default AIModal;
